import { Component, OnDestroy, inject } from '@angular/core';
import { forEach } from 'lodash-es';
import { SearchField } from '../../../core/models/search-field.model';
import { CaptureSearchResult } from '../../../core/models/capture-lists/capture-search-result.model';
import { UserPresenceService } from 'app/core/services/user-presence.service';
import { CaptureSearchComponent } from '../../../captures/components/capture-search/capture-search.component';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
import { CaptureStatusPipe } from 'app/shared/pipes/capture-status.pipe';
import { ProviderNameWithNpiPipe } from '../../../shared/pipes/provider-name-with-npi.pipe';

@Component({
    selector: 'app-client-portal-search',
    templateUrl: './client-portal-search.component.html',
    imports: [CaptureSearchComponent,
              RouterLink,
              UserPresenceComponent,
              DatePipe,
              CaptureStatusPipe,
              ProviderNameWithNpiPipe]
})
export class ClientPortalSearchComponent implements OnDestroy {
  private userPresenceService = inject(UserPresenceService);

  captures: CaptureSearchResult[] = [];

  searchFields = [
    new SearchField('claimIdentifierSubstring', 'Claim ID'),
    new SearchField('patientFirstName', 'Patient First Name'),
    new SearchField('patientLastName', 'Patient Last Name'),
  ];

  ngOnDestroy(): void {
    this.userPresenceService.unsubscribeAll();
  }

  onSearchComplete(captures: CaptureSearchResult[]) {
    this.captures = captures;
    this.subscribeToUserPresence();
  }

  private subscribeToUserPresence() {
    this.userPresenceService.unsubscribeAll();

    forEach(this.captures, (capture: CaptureSearchResult) => {
      this.userPresenceService.subscribe("capture", capture.id)
    });
  }
}
